export default __webpack_public_path__ + "static/media/img4.155aa922.jpg";